/* Copyright (c) 2025 MOCA Systems, Inc.  All rights reserved. */

import { CalendarWorkdays } from '@touchplan/ticket';
import { DateUtils } from './date-utils';

/**
 * This class is temporary while we implement granular time planning and scheduling.
 * This logic was copied from the WorkdaysComponent and can be replaced by what ever new thing is
 * written to replace how we calculate everything from CalendarWorkdays
 */
export class WorkDayUtils {
	public static calculateFinishDate(start: string, dayCount: number) {
		const startDate = DateUtils.stringToLocalTimezoneDate(start) || new Date();

		// Adjust date to calculate the finish date
		const finishDate = new Date(startDate);
		finishDate.setDate(startDate.getDate() + dayCount - 1);

		return finishDate;
	}

	public static calculateWorkDays(
		calendarWorkdays: CalendarWorkdays,
		ticketWorkdayBooleans: boolean[],
		liveStart?: string,
		roleId?: string
	): Array<{ date: Date; enabled: boolean; startOfWork: boolean }> {
		const workDays: Array<{ date: Date; enabled: boolean; startOfWork: boolean }> = [];

		liveStart = liveStart || DateUtils.dateToStandardStringFormat(new Date());
		const startDate: Date | null = liveStart ? DateUtils.stringToLocalTimezoneDate(liveStart) : new Date();
		if (startDate) {
			const finishDate = WorkDayUtils.calculateFinishDate(liveStart, ticketWorkdayBooleans.length);
			const finish = DateUtils.dateToStandardStringFormat(finishDate);

			const planRoleWorkdayBooleans: boolean[] = calendarWorkdays.calculateWorkdays(
				liveStart,
				finish,
				roleId
			);

			planRoleWorkdayBooleans.forEach((workDay, index) => {
				const currentDate = new Date(startDate);
				currentDate.setDate(currentDate.getDate() + index);
				workDays.push({
					date: currentDate,
					enabled: ticketWorkdayBooleans[index],
					startOfWork: index === 0,
				});
			});
		}

		return workDays;
	}
}
